var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.693,
    height: 27.693,
    viewBox: "0 0 27.693 27.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marca",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1124",
    "data-name": "Grupo 1124",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1553",
    "data-name": "Caminho 1553",
    d: "M31.706,20.018a1.531,1.531,0,0,0-1.439-.94h-.94a.495.495,0,0,0,0,.989h1a.478.478,0,0,1,.47.346.489.489,0,0,1-.183.564l-3.12,2.29a1.5,1.5,0,0,0-.539,1.667l1.2,3.7a.5.5,0,0,1-.188.569.467.467,0,0,1-.574,0l-3.12-2.285a1.479,1.479,0,0,0-1.751,0L19.4,29.2a.467.467,0,0,1-.574,0,.5.5,0,0,1-.188-.569l1.2-3.7a1.5,1.5,0,0,0-.539-1.667l-3.12-2.29a.489.489,0,0,1-.183-.564.478.478,0,0,1,.47-.346h3.857a1.481,1.481,0,0,0,1.414-1.034l1.192-3.7a.492.492,0,0,1,.94,0l1.192,3.7a1.481,1.481,0,0,0,1.414,1.034h.88a.495.495,0,0,0,0-.989h-.88a.488.488,0,0,1-.47-.346l-1.2-3.7a1.478,1.478,0,0,0-2.819,0l-1.2,3.7a.488.488,0,0,1-.47.346h-3.8a1.531,1.531,0,0,0-1.439.94,1.484,1.484,0,0,0,.5,1.761l3.125,2.285a.5.5,0,0,1,.178.564l-1.192,3.7A1.487,1.487,0,0,0,19.981,30l3.125-2.29a.49.49,0,0,1,.574,0L26.806,30a1.449,1.449,0,0,0,1.681.045,1.678,1.678,0,0,0,.579-1.79L27.9,24.627a.5.5,0,0,1,.178-.564L31.2,21.779a1.484,1.484,0,0,0,.5-1.761Z",
    transform: "translate(-9.547 -9.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1554",
    "data-name": "Caminho 1554",
    d: "M31.2,27.737H30.21V10.429a.495.495,0,1,0-.989,0V27.737h-.989a.5.5,0,0,0-.495.495v.989H7.956v-.989a.5.5,0,0,0-.495-.495H6.473V23.286a.495.495,0,0,0-.989,0v4.451H4.495A.5.5,0,0,0,4,28.232V31.2a.5.5,0,0,0,.495.495H7.462a.5.5,0,0,0,.495-.495V30.21H27.737V31.2a.5.5,0,0,0,.495.495H31.2a.5.5,0,0,0,.495-.495V28.232A.5.5,0,0,0,31.2,27.737ZM6.967,30.7H4.989V28.726H6.967Zm23.737,0H28.726V28.726H30.7ZM31.2,4H28.232a.5.5,0,0,0-.495.495v.989H7.956V4.495A.5.5,0,0,0,7.462,4H4.495A.5.5,0,0,0,4,4.495V7.462a.5.5,0,0,0,.495.495h.989V21.308a.495.495,0,1,0,.989,0V7.956h.989a.5.5,0,0,0,.495-.495V6.473H27.737v.989a.5.5,0,0,0,.495.495h.989v.495a.495.495,0,1,0,.989,0V7.956H31.2a.5.5,0,0,0,.495-.495V4.495A.5.5,0,0,0,31.2,4ZM6.967,6.967H4.989V4.989H6.967Zm23.737,0H28.726V4.989H30.7Z",
    transform: "translate(-4 -4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarca);
export default __webpack_public_path__ + "static/media/marca.08481e41c5c7192e8a918d65bb4e8da5.svg";
export { ForwardRef as ReactComponent };